import { render, staticRenderFns } from "./Reading.vue?vue&type=template&id=53156808&"
import script from "./Reading.vue?vue&type=script&lang=js&"
export * from "./Reading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports